/**
 * Finds the full tree route (e.g. "a/b/c") for a given content id.
 *
 * In the outline tree, each item's key is a route string where segments
 * are joined by "/". The leaf segment represents the content id itself.
 * This function searches treeItems and returns the first
 * route whose last segment matches the given currentContentId.
 *
 * Example:
 *   treeItems = { "root/abc": {}, "root/xyz/123": {} }
 *   currentContentId = "123"
 *   -> returns "root/xyz/123"
 *
 * Returns an empty string if no matching route is found.
 */
const findCurrentContentIdTreeRoute = <T>(
  treeItems: Record<string, T>,
  currentContentId: string | undefined,
) => {
  if (!currentContentId) return "";
  return (
    Object.keys(treeItems).find((item) => {
      const routeArray = item.split("/") || [];
      return routeArray[routeArray.length - 1] === currentContentId;
    }) || ""
  );
};

export default findCurrentContentIdTreeRoute;
